const WIDGET_1_DASHBOARD_1_DATA_ITEM = "cPcvesqWRtH";

const WIDGET_2_DASHBOARD_1_DATA_ITEM = "cwhEsbBe6Zs";

const WIDGET_3_DASHBOARD_1_DATA_ITEM = "dJhWRKs0fcq";

const WIDGET_4_DASHBOARD_1_DATA_ITEM = "ZGuni8UTDTK";

const WIDGET_5_DASHBOARD_1_DATA_ITEM = "U2Tmx7kjSzc";

const WIDGET_6_DASHBOARD_1_DATA_ITEM = "OjUHkTCv6cd";

const WIDGET_7_DASHBOARD_1_DATA_ITEM_1 = "cPcvesqWRtH";

const WIDGET_7_DASHBOARD_1_DATA_ITEM_2 = "cwhEsbBe6Zs";

const WIDGET_7_DASHBOARD_1_DATA_ITEM_3 = "dJhWRKs0fcq";

const WIDGET_8_DASHBOARD_1_DATA_ITEM_1 = "ZGuni8UTDTK";

const WIDGET_8_DASHBOARD_1_DATA_ITEM_2 = "U2Tmx7kjSzc";

const WIDGET_8_DASHBOARD_1_DATA_ITEM_3 = "OjUHkTCv6cd";

const WIDGET_9_DASHBOARD_1_DATA_ITEMS = [
  "sISjKc2LEDg",
  "FSLrz90vXKf",
  "cPcvesqWRtH",
  "kyVKK0JcRPJ",
  "cwhEsbBe6Zs",
  "dJhWRKs0fcq",
];

const WIDGET_10_DASHBOARD_1_DATA_ITEM_1 = "ZGuni8UTDTK";

const WIDGET_10_DASHBOARD_1_DATA_ITEM_2 = "U2Tmx7kjSzc";

const WIDGET_10_DASHBOARD_1_DATA_ITEM_3 = "OjUHkTCv6cd";

const WIDGET_11_DASHBOARD_1_DATA_ITEM_1 = "cPcvesqWRtH";

const WIDGET_11_DASHBOARD_1_DATA_ITEM_2 = "cwhEsbBe6Zs";

const WIDGET_11_DASHBOARD_1_DATA_ITEM_3 = "dJhWRKs0fcq";

const months = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

export {
  WIDGET_1_DASHBOARD_1_DATA_ITEM,
  WIDGET_2_DASHBOARD_1_DATA_ITEM,
  WIDGET_3_DASHBOARD_1_DATA_ITEM,
  WIDGET_4_DASHBOARD_1_DATA_ITEM,
  WIDGET_5_DASHBOARD_1_DATA_ITEM,
  WIDGET_6_DASHBOARD_1_DATA_ITEM,
  WIDGET_7_DASHBOARD_1_DATA_ITEM_1,
  WIDGET_7_DASHBOARD_1_DATA_ITEM_2,
  WIDGET_7_DASHBOARD_1_DATA_ITEM_3,
  WIDGET_8_DASHBOARD_1_DATA_ITEM_1,
  WIDGET_8_DASHBOARD_1_DATA_ITEM_2,
  WIDGET_8_DASHBOARD_1_DATA_ITEM_3,
  WIDGET_9_DASHBOARD_1_DATA_ITEMS,
  WIDGET_10_DASHBOARD_1_DATA_ITEM_1,
  WIDGET_10_DASHBOARD_1_DATA_ITEM_2,
  WIDGET_10_DASHBOARD_1_DATA_ITEM_3,
  WIDGET_11_DASHBOARD_1_DATA_ITEM_1,
  WIDGET_11_DASHBOARD_1_DATA_ITEM_2,
  WIDGET_11_DASHBOARD_1_DATA_ITEM_3,
  months
};
